module.exports = __webpack_public_path__ + "static/media/Car_Engine_-_Dashboard_Lights_68-512.1c84bd73.png";